import {AxiosInstance, CancelToken} from "axios";
import {apiHost} from "../rest/restApi";
import {User} from "../../../administration/users/User";

export const uploadFile = async (axios: AxiosInstance, relativeUri: string, file: File, onUploadProgress?: (progressEvent: any) => void, cancelToken?: CancelToken): Promise<any> => {
  const form = new FormData();
  form.append('file', file, file.name || '');
  const baseUri = apiHost + '/' + relativeUri;

  const response = await axios({
    method: 'post',
    url: baseUri,
    data: form,
    cancelToken: cancelToken,
    onUploadProgress: onUploadProgress
  });

  return response.data;
};

export const importUsersFromCSVFile = async (axios: AxiosInstance, file: File): Promise<User[]> => {
  const formData = new FormData();
  formData.append("file", file, "upload.csv");

  const response = await axios({
    method: 'post',
    url: "/api/import-users",
    headers: {"Content-Type": "multipart/form-data"},
    data: formData,
  });
  return response.data;
}
